

export function YoutubeLinks() {
    return (
        <>
            <div id="cta" className="section">

            <div className="bg-image bg-parallax overlay bg-youtube-link"></div>
           
                <div className="container">
                    <div className="row">

                        <div className="col-md-3 col-sm-6 col-xs-10">
                            <div className="course youtube-video-link">
                                <a target="_tab" href="https://www.youtube.com/channel/UC6hjO6A1FvKKfMlAA7EOJDA/playlists" className="course-img m-0">
                                    <img src={require("../../../img/angularproject.png")} alet=""></img>
                                    <i className="course-link-icon fa fa-link"></i>
                                </a>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-6 col-xs-10">
                            <div className="course youtube-video-link">
                                <a target="_tab" href="https://www.youtube.com/watch?v=PS8sZH2Lijw&list=PLtEvrxN7cgTGVKEv9C5xyUfd-ufkXSdj8" className="course-img m-0">
                                    <img src={require("../../../img/jsseries.png")} alet=""></img>
                                    <i className="course-link-icon fa fa-link"></i>
                                </a>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-6 col-xs-10">
                            <div className="course youtube-video-link">
                                <a target="_tab" href="https://www.youtube.com/channel/UC6hjO6A1FvKKfMlAA7EOJDA/playlists" className="course-img m-0">
                                    <img src={require("../../../img/exploremore.png")} alet=""></img>
                                    <i className="course-link-icon fa fa-link"></i>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}